import {config} from 'config/env';
import {getStoreAreaFilter} from 'store/types/app';
import {StoreAreas, StoreInfoLocationSvcResponse} from 'types';
import {SubDistrict} from 'types/location';
import {get} from 'utils/api';
import {locationToStoreAreas} from 'utils/location';

export const getStoreInfoByLocationV2 = async (
  zipcode: string,
  subdistrict: string
): Promise<StoreInfoLocationSvcResponse> => {
  const endPointURL = new URL(`${config.MAKNET_WEB_BASE_URL}/location/api/v1/stores`).toString();
  const payload = {zipCode: zipcode, subDistrict: subdistrict};
  const stores = await get(endPointURL, true, false, false, undefined, true, payload);
  return {
    zipcode,
    subdistrict,
    stores
  };
};

export const getStoreAreasV2 = async (zipCode: string): Promise<StoreAreas[]> => {
  const endPointURL = new URL(`${config.MAKNET_WEB_BASE_URL}/location/api/v1/stores/store-areas`).toString();
  const payload = {zipCode};
  const storeAreasLocations = await get(endPointURL, true, false, false, undefined, true, payload);
  return locationToStoreAreas(storeAreasLocations.data);
};

export const getAllStoreAreasV2 = async (): Promise<StoreAreas[]> => {
  const endPointURL = new URL(`${config.MAKNET_WEB_BASE_URL}/location/api/v1/stores/store-areas`).toString();
  const storeAreasLocations = await get(endPointURL, true, false, false, undefined, true, undefined);
  return locationToStoreAreas(storeAreasLocations.data);
};

export const getStoreArea = async (filter: getStoreAreaFilter): Promise<SubDistrict> => {
  const endPointURL = new URL(`${config.MAKNET_WEB_BASE_URL}/location/api/v1/stores/store-areas`).toString();
  const storeArea = await get(endPointURL, true, false, false, undefined, true, filter);
  return storeArea.data?.[0];
};
